import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['kaigoHokenTable']
  static values = {
    unit: Array,
    category: Number,
    areaPrice: Number,
    careLevel: Array,
    careInsuranceRate: Array,
  }

  connect () {
    this.insertKaigoHokenTable()
  }

  calcKaigoHoken () {
    const data = this.careLevelValue.map(careLevel => {
      const record = {
        heading: '',
        values: [],
      }

      if (careLevel.value) {
        record.heading = `${careLevel.category}${careLevel.value}`
      }

      this.careInsuranceRateValue.forEach(careInsuranceRate => {
        const unit = this.unitValue.find(element => element.category_id === Number(this.categoryValue) && element.care_level_id === Number(careLevel.id))
        if (unit) {
          const value = Math.round(Number(this.areaPriceValue) * unit.value * (Number(careInsuranceRate.id) * 0.1))
          record.values.push(`${new Intl.NumberFormat().format(value)}円`)
        }
      })

      return record
    })

    return data
  }

  insertKaigoHokenTable () {
    const data = this.calcKaigoHoken()
    const thead = document.createElement('thead')
    const tbody = document.createElement('tbody')
    const topRow = document.createElement('tr')
    const blankHeading = document.createElement('th')
    blankHeading.innerText = ' '
    topRow.appendChild(blankHeading)

    this.careInsuranceRateValue.forEach(careInsuranceRate => {
      const heading = document.createElement('th')
      heading.innerText = careInsuranceRate.name
      topRow.appendChild(heading)
    })

    thead.appendChild(topRow)
    this.kaigoHokenTableTarget.appendChild(thead)

    data.forEach(record => {
      if (record.heading && record.values.length === this.careInsuranceRateValue.length) {
        const row = document.createElement('tr')
        const heading = document.createElement('th')
        heading.innerText = record.heading
        row.appendChild(heading)

        record.values.forEach(value => {
          const cell = document.createElement('td')
          cell.innerText = value
          row.appendChild(cell)
        })

        tbody.appendChild(row)
      }
    })

    this.kaigoHokenTableTarget.appendChild(tbody)
  }
}
